'use client';

// BL-2553 — the phone brand bar, on root screens only. A drill-down screen (an auction, online or
// offline) starts with its own Back row, so the shell leaves the bar off it.

import { usePathname, useSearchParams } from 'next/navigation';
import { isDrillDownRoute } from '@auctogon/admin-isomorphic/isomorphic/shell/drill-down-routes';
import MobileNavBar from './MobileNavBar';

/**
 * The dashboard's phone bar, or nothing on a drill-down screen.
 *
 * @param props.className - passed to the bar (the shell hides it at the desktop tier).
 * @returns the bar on a root screen; null on a drill-down.
 */
export default function ShellBrandBar({ className }: { className?: string }) {
    // Both read null outside the app router (a test rendering the shell bare): a root screen.
    const pathname = usePathname() ?? '';
    const search = useSearchParams()?.toString() ?? '';
    if (isDrillDownRoute({ pathname, search })) return null;
    return <MobileNavBar className={className} />;
}
